import { render, staticRenderFns } from "./BildeVariabel.vue?vue&type=template&id=90d1e11a&"
import script from "./BildeVariabel.vue?vue&type=script&lang=js&"
export * from "./BildeVariabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports